
// Re-export the Toaster component from sonner with custom configuration
import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster 
      position="top-right"
      toastOptions={{
        duration: 3000,
        className: "toast-animation",
        style: {
          border: "1px solid var(--border)",
          borderRadius: "0.5rem",
        }
      }}
      closeButton={true}
      richColors={true}
    />
  );
}
